import Alpine from "alpinejs";

window.Alpine = Alpine;

async function nevisApi(url, options = {}) {
  return fetch(url, {
      headers: { "Content-Type": "application/json", }, ...options,
  })
}

Alpine.data('feedbackControls', function () {
    return {
      _token: null,
      _errors: null,
      action: null,
      selectedValue: null,
      date: null,
      processing: true,

      init() {
        this.action = this.$el.action;
        this._token = this.$el.querySelector('[name=_token]').value;
        this.fetchFeedbackForUser();
      },

      async fetchFeedbackForUser() {
        const response = await nevisApi(this.action)
        const data = await response.json();
        this.selectedValue = data?.value ?? null;
        this.date = data?.date ?? null;
        this.processing = false;
      },

      async sendFeedback(value) {
        this.clearErrors();
        this.processing = true;
        try {
          const response = await nevisApi(this.action, {
            method: 'POST',
            body: JSON.stringify({
              _token: this._token, 
              feedback: value,
            }),
          })
          const data = await response.json();
          if(!response.ok) {
            this._errors = data;
          } else {
            this.selectedValue = data.value;
            this.date = data.value;
          }
          this.processing = false;
        } catch(e) {
          alert('Something went wrong, please contact support.')
        }
      },

      positiveFeedback() {
        this.sendFeedback(this.selectedValue === 1 ? 0 : 1);
      },

      negativeFeedback() {
        this.sendFeedback(this.selectedValue === -1 ? 0 : -1);
      },

      getError(errorKey) {
        return this._errors?.[errorKey]
      },

      clearErrors() {
        this._errors = null
      }

    }
});

Alpine.start();

function handleConfirmButton(e) {
    if (!confirm(this.dataset.confirm)) return e.preventDefault();
    return this;
}

document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
      document
        .querySelectorAll("[data-confirm]")
        .forEach((el) => el.addEventListener("click", handleConfirmButton));
        
    }
  }

(function() {

  function openModal() {
      var modalTrigger = document.getElementsByClassName('jsModalTrigger');
      for(var i = 0; i < modalTrigger.length; i++) {
          modalTrigger[i].onclick = function() {
            var target = this.getAttribute('href').substr(1);
            var modalWindow = document.getElementById(target);

            modalWindow.classList ? modalWindow.classList.add('open') : modalWindow.className += ' ' + 'open'; 
          }
      }   
  }

  function closeModal(){
    var closeButton = document.getElementsByClassName('jsModalClose');
    var closeOverlay = document.getElementsByClassName('jsOverlay');

      for(var i = 0; i < closeButton.length; i++) {
        closeButton[i].onclick = function() {
          var modalWindow = this.parentNode.parentNode;

          modalWindow.classList ? modalWindow.classList.remove('open') : modalWindow.className = modalWindow.className.replace(new RegExp('(^|\\b)' + 'open'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
      }   

      for(var i = 0; i < closeOverlay.length; i++) {
        closeOverlay[i].onclick = function() {
          var modalWindow = this.parentNode;

          modalWindow.classList ? modalWindow.classList.remove('open') : modalWindow.className = modalWindow.className.replace(new RegExp('(^|\\b)' + 'open'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
      }  

  }

  function ready(fn) {
    if (document.readyState != 'loading'){
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }
  ready(openModal);
  ready(closeModal);
  
}());